import { Action } from "redux";

import { OrganizationKeyName } from "../../../model/Organization";

export const MODIFY_ORG_ACCESS = "ADMIN-USER:MODIFY_ORG_ACCESS";

export interface ModifyOrgAccessAction extends Action {
  type: typeof MODIFY_ORG_ACCESS;
  organization: OrganizationKeyName;
  organizationId: string;
  userId: number;
  add: boolean;
}

export const modifyOrgAccessAction = (
  organization: OrganizationKeyName,
  organizationId: string,
  userId: number,
  add: boolean
): ModifyOrgAccessAction => ({
  type: MODIFY_ORG_ACCESS,
  organization,
  organizationId,
  userId,
  add,
});
